import { createFileRoute } from '@tanstack/react-router'
import { RoomScreen } from '../../../components/assemblies/RoomScreen'

/** The room screen of a meeting, for the projector (spec 2026-10-05-09). */
export const Route = createFileRoute('/$org/assemblies/$uid_/room')({
  component: RoomScreen,
})
